import "./ProfilePicture.scss";
import { useEffect, useRef, useState } from "react";

const ProfilePicture = ({register , setValue , defaultImage }) => {
  const hiddenInputRef = useRef();

  const [preview, setPreview] = useState('');

  const handleUploadedFile = (event) => {
    const file = event.target.files[0];
    setValue('photo',file);
    const urlImage = URL.createObjectURL(file);

    setPreview(urlImage);
  };

  const onUpload = (e) => {
    e.preventDefault();
    hiddenInputRef.current.click();
  };

  useEffect(()=>{
    register('photo');
  },[register])

  const uploadButtonLabel = preview ? "تغيير الصورة" : "تحميل صورة";
  return (
    <div className="profile-picture">
      <div className="label">الصورة الشخصية</div>
      <input
        type="file"
        name="photo"
        className="file-input"
        onChange={handleUploadedFile}
        ref={hiddenInputRef}
      />

      <img className="avatar" src={preview ? preview : defaultImage} alt="profile" />

      <button className="upload-button" onClick={onUpload}>
        {uploadButtonLabel}
      </button>
    </div>
  );
};

export default ProfilePicture;
